<template>
<div  class="page_activityapply" style="float:left; padding:20px 40px">
    <a class="btn  on_js"  v-if="isClick" @click="fnOnLoadMessage(false, 'like')">좋아요</a>
    <a class="btn "  v-if="!isClick" @click="fnOnLoadMessage(true, 'like')">좋아요</a>
    <a class="btn on_js" >찜하기</a>
</div>
</template>

<script>
import Axios from 'axios'

export default{
    data: function () {
      return {
          socket : null,
          isClick:false,
          detail:{}
      }
    }
    , model:{
          prop:'alarmProp'
        , event : 'alarmEvent'
    }
    , props:{
        alarm : Object
    }
    , created: function () {
        //this.fnOnWebSocketInit();
         
    }
    , mounted: function () {
        this.fnOnWebSocketInit();
    }
    , methods: {
        fnOnWebSocketInit:function(){
            let vm = this;

            let _socket = new SockJS('http://localhost:8080/socket/receiveSocket/');
            this.socket = _socket;
            this.socket.onopen = function(){
            } 
        }
        , fnOnLoadMessage:function(_param, _like){
            let vm = this;
            vm.isClick = event;
         
            vm.fnOnSaveMessage(_param, _like);
        }
        , fnOnSaveMessage:function(_param, _like){
             let vm = this;
            vm.fnOnViewMessage(_param, _like);
            
        }

         , fnOnViewMessage:function(_param, _like){
            let vm = this;
            let param = {
                 paramUid: this.alarm.detail.uidKey
                ,paramUsr:''
                ,paramText:'USR'
                ,version: _like
                ,paramLogDetail:{
                      cmm_usr_key : ''
                    , cmm_cntr_key : this.alarm.detail.center
                    , cmm_like : (_param) ? 'Y' : 'N'
                    , cmm_save : (_param) ? 'Y' : 'N'
                    , cmm_uid_key : this.alarm.detail.uidKey
                }
            };
            let _send = {
                message : (_like == 'like') ? '좋아요를 누르셨습니다.' : '찜하기를 누르셨습니다.'
            };
            vm.socket.send(JSON.stringify(_send));
            vm.socket.onmessage = function(evt){
                        let _message = JSON.parse(evt.data);
                        vm.$emit("update-message", _message );
              
            }
            Axios.post("/api/log/basic/update", param).then(function(response) {
                response.data.paramLogDetail.cmm_updt_dt = '';
                vm.socket.onclose = function(evt){
                      // vm.fnOnViewMessage(param);
                }
            }).catch(function(ex) {
                console.log(ex);
            });

        } 

        

    }
  }
</script>